var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"support_chat_ws"},[_c('div',{attrs:{"id":"frame"}},[_c('chat-user-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }